import { useQuery } from '@tanstack/react-query';
import api from '@/services/api';

export type FieldSchema = {
  key: string; label: string; data_type: string; fk_resource: string;
  choices: { value: string; label: string }[]; section: string;
  is_required: boolean; is_rate_dimension: boolean;
  validation: Record<string, unknown>; display_order: number;
};
export type PremiumBase = { code: string; label: string };
/** #332: how many insured people a health product carries. Null for every other type. */
export type MemberStructure = {
  mode: 'individual' | 'floater' | 'group';
  min: number;
  max: number | null;
  relation_required: boolean;
};
export type ResolvedSchema = {
  fields: FieldSchema[]; premiumBases: PremiumBase[]; rateDimensions: string[];
  memberStructure?: MemberStructure | null;
};

export function mapSchemaResponse(raw: any): ResolvedSchema {
  return {
    fields: (raw?.fields ?? []) as FieldSchema[],
    premiumBases: (raw?.premium_bases ?? []) as PremiumBase[],
    rateDimensions: (raw?.rate_dimensions ?? []) as string[],
    memberStructure: (raw?.member_structure ?? null) as MemberStructure | null,
  };
}

export function useInsuranceTypeSchema(
  insuranceType?: string, group?: string, subgroup?: string,
  appliesTo: 'policy' | 'quote' = 'policy',
  product?: string,
) {
  return useQuery<ResolvedSchema>({
    queryKey: ['insurance-type-schema', insuranceType, group, subgroup, appliesTo, product],
    queryFn: async () => {
      const response = await api.get(`/products/types/${insuranceType}/schema/`, {
        params: { applies_to: appliesTo, group: group || undefined, subgroup: subgroup || undefined,
          product: product || undefined },
      });
      return mapSchemaResponse(response.data);
    },
    enabled: !!insuranceType,
    staleTime: 5 * 60 * 1000,
  });
}
